import TopLocationsState from './TopLocationsState';

export default TopLocationsState;
